import { formatBaasStablesNetworkLabel } from "../../../../../Services/baasStablesWalletApi";

const NETWORK_STYLES = {
  Ethereum: "bg-indigo-50 text-indigo-700 dark:bg-indigo-950/40 dark:text-indigo-300",
  Polygon: "bg-violet-50 text-violet-700 dark:bg-violet-950/40 dark:text-violet-300",
  Solana: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400",
  Tron: "bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300",
  Base: "bg-sky-50 text-sky-700 dark:bg-sky-950/40 dark:text-sky-300",
};

export const BaasStablesNetworkBadge = ({ network }) => (
  <span
    className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${NETWORK_STYLES[network] ?? "bg-gray-100 text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-300"}`}
  >
    {formatBaasStablesNetworkLabel(network)}
  </span>
);
